import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function Header1Styles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .header-1": {
            [MobileBreakpoint]: {
                fontSize: "24px !important",
                textAlign: "center !important",
            },
        },

        "& .ecommerce-product-name": {
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "uppercase",
            marginBottom: "10px",

            [MobileBreakpoint]: {
                textAlign: "center !important",
            },
        },
    };
}

export default function Header1(props) {
    const LI = useLoremIpsum();

    const variables = props.variables;

    if (!props.text && !props.useVariable) {
        return null;
    }

    let text = props.text;
    if (!props.text && props.useVariable) {
        if (variables[props.useVariable]) {
            text = variables[props.useVariable];
        } else {
            text = LI.Header;
        }
    }

    if (!text) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["header-1"] });
    return (
        <div>
            {variables.ProductType === "ecommerce" && (
                <div className="ecommerce-product-name">{variables.ProductName}</div>
            )}

            <h1 {...elProps}>{text || LI.Header}</h1>
        </div>
    );
}
